import React, { useEffect, useState } from "react";
import { FormProvider, useForm } from "react-hook-form";
import { useDispatch, useSelector } from "react-redux";
import { useTranslation } from "react-i18next";
import { toast } from "react-toastify";

import css from "./OrdersDaysCountModal.module.css";
import {
  packsActions,
  periodsActions,
} from "../../../../store/slices/settings-slices";
import { ordersService } from "../../../../services/orders-services";
import { ordersActions } from "../../../../store/slices/orders-slices";
import { OrdersCalendarModal } from "../OrdersCalendarModal/OrdersCalendarModal";
import { OrdersCounterModal } from "../OrdersCounterModal/OrdersCounterModal";
import { OrdersSunSatDaysModal } from "../OrdersSunSatDaysModal/OrdersSunSatDaysModal";
import { OrdersSingleDayModal } from "../OrdersSingleDayModal/OrdersSingleDayModal ";

const OrdersDaysCountModal = ({ setIsOpenDaysCountModal }) => {
  const dispatch = useDispatch();
  const { t } = useTranslation();
  const methods = useForm();
  const { watch, setValue } = methods;

  const [selectedDates, setSelectedDates] = useState([]);
  const [days, setDays] = useState(1);
  const [lastSelectedDate, setLastSelectedDate] = useState(null);

  const watchSat = watch("sat");
  const watchSun = watch("sun");

  const { periods, trigger } = useSelector((store) => store.periods);
  const { selectedDatesArray, currentDaysCount } = useSelector(
    (store) => store.orders
  );

  // Initialize with existing selected dates from Redux store
  useEffect(() => {
    if (selectedDatesArray && selectedDatesArray.length > 0) {
      setSelectedDates(selectedDatesArray);
      setDays(selectedDatesArray.length);

      // Set the last selected date to the last date in the array
      const lastDate = new Date(
        selectedDatesArray[selectedDatesArray.length - 1]
      );
      setLastSelectedDate(lastDate);
    } else if (currentDaysCount > 1) {
      setDays(currentDaysCount);
    }
  }, [selectedDatesArray, currentDaysCount]);

  // Отримання доступних періодів при оновленні тригера
  useEffect(() => {
    dispatch(periodsActions.getAllPeriods());
  }, [trigger]);

  // збереження вибраних дат та запит на відповідні страви
  const onSubmit = async () => {
    try {
      const res = await ordersService.getAllMenuDishesForDate(selectedDates);
      dispatch(ordersActions.changeMenuDishesPacksForDates(res.data));
      dispatch(ordersActions.changeCurrentDaysCount(days));
      dispatch(ordersActions.changeSelectedDatesArray(selectedDates));

      // Find the matching period based on days count and apply its discount
      const matchingPeriod = periods.find(
        (period) => period.daysCount === days
      );
      if (matchingPeriod) {
        dispatch(ordersActions.changeCurrentDiscount(matchingPeriod.discount));
      } else {
        dispatch(ordersActions.changeCurrentDiscount(0));
      }

      dispatch(packsActions.changeTrigger());

      toast.success("successful");
      setIsOpenDaysCountModal(false);
    } catch (error) {
      console.error(t("error"), error);
      toast.error(t("error"));
    }
  };

  return (
    <div className={css.overlay}>
      <div className={css.modal}>
        <div className={css.header}>
          <div className={css.title}></div>
          <div
            className={css.closeButton}
            onClick={() => setIsOpenDaysCountModal(false)}
          >
            &times;
          </div>
        </div>

        <FormProvider {...methods}>
          <form onSubmit={methods.handleSubmit(onSubmit)} className={css.form}>
            <div className={css.infoBlock}>
              <div className={css.days}>
                {periods.length > 0 &&
                  periods.map((obj) => (
                    <OrdersSingleDayModal
                      key={obj.id}
                      period={obj}
                      setDays={setDays}
                      setSelectedDates={setSelectedDates}
                      lastSelectedDate={lastSelectedDate}
                      watchSat={watchSat}
                      watchSun={watchSun}
                    />
                  ))}
              </div>

              <div className={css.calendar}>
                <OrdersCalendarModal
                  days={days}
                  setDays={setDays}
                  selectedDates={selectedDates}
                  setSelectedDates={setSelectedDates}
                  lastSelectedDate={lastSelectedDate}
                  setLastSelectedDate={setLastSelectedDate}
                />
              </div>

              <div className={css.actions}>
                <div className={css.counter}>
                  <OrdersCounterModal
                    days={days}
                    setDays={setDays}
                    setSelectedDates={setSelectedDates}
                    lastSelectedDate={lastSelectedDate}
                    watchSat={watchSat}
                    watchSun={watchSun}
                  />
                </div>
                <div className={css.checkboxes}>
                  <OrdersSunSatDaysModal />
                </div>
              </div>
            </div>

            <div className={css.buttonsBlock}>
              <button
                type="button"
                className={css.cancelButton}
                onClick={() => setIsOpenDaysCountModal(false)}
              >
                {t("modal-cancel")}
              </button>
              <button type="submit" className={css.submitButton}>
                OK
              </button>
            </div>
          </form>
        </FormProvider>
      </div>
    </div>
  );
};

export default OrdersDaysCountModal;
